<template>
  <div>
    <b-form @submit.prevent="addGrant(grant)">
      <b-form-group label="Grant Number, Title, or other Identifying Information" label-class="control-label workload-course-label" :class="{ 'invalid-group': $v.grant.description.$error }">
        <b-form-input v-model="grant.description" :class="{ 'is-invalid': $v.grant.description.$error }"></b-form-input>
      </b-form-group>
      <b-form-group label="Notes" label-class="control-label workload-course-label">
        <b-form-textarea :rows="3" placeholder="Enter notes..." v-model="grant.notes"></b-form-textarea>
      </b-form-group>
      <b-button type="submit">Add to Request</b-button>
    </b-form>

    <div>
      <b-table striped hover small
        :fields="grantFields"
        :items="internalGrants">
        <template v-slot:cell(grant)="data">
          {{ data.item.description }}
        </template>

        <template v-slot:cell(controls)="data">
          <div class="text-right">
            <b-form-checkbox v-model="data.item.approved">Approved</b-form-checkbox>
          </div>
          <div class="text-right">
            <font-awesome-icon icon="times" class="remove-icon mx-1" @click.prevent="removeGrant(data.item)"></font-awesome-icon>
          </div>
        </template>

      </b-table>
    </div>

    
  </div>
</template>

<script>
import * as _ from "lodash"; // eslint-disable-line no-unused-vars
import { required, decimal, between } from "vuelidate/lib/validators";
export default {
  name: "BuyoutGrantApprovals",
  data() {
    return {
      grant: {
        description: null,
        percentage: null,
        notes: "",
      },
      grantFields: [
        { key: "grant", label: "" },
        { key: "controls", label: "" },
      ],
      internalGrants: [],
    };
  },

  props: {
    value: {
      type: Boolean,
      required: false,
    },
    grants: {
      required: true,
      type: Array,
    },
    totalPercent: {
      type: Number,
      required: true,
    },
    buyoutId: {
      type: Number,
      required: true,
    },
  },

  computed: {
    totalApprovedPercent() {
      let total = 0;
      _.forEach(this.internalGrants, (grant) => {
        if (grant.approved) {
          total = total += grant.percentage;
        }
      });
      return total;
    },
  },

  validations() {
    var validations = {
      grant: {
        description: { required },
      },
    };
    return validations;
  },

  methods: {
    addGrant(grant) {
      this.$v.grant.$touch();

      if (!this.$v.grant.$error) {
        // this.$emit("addApprovedGrant", {
        //   description: grant.description,
        //   percentage: parseFloat(grant.percentage),
        //   notes: grant.notes,
        //   buyoutRequestId: this.buyoutId,
        //   approved: true,
        //   requested: false
        // });
        this.internalGrants.push({
          description: grant.description,
          notes: grant.notes,
          buyoutRequestId: this.buyoutId,
          approved: true,
          requested: false,
        });
        this.grant.description = null;
        this.grant.percentage = null;
        this.grant.notes = null;
        this.$nextTick(() => {
          this.$v.grant.$reset();
        });
        //this.$v.grantNumber.$touch();
      }
    },
    removeGrant(grant) {
      var index = _.findIndex(this.internalGrants, (item) => {
        return item.description === grant.description;
      });
      this.internalGrants.splice(index, 1);
    },
  },
  watch: {
    value: function() {
      if (this.value) {
        this.$emit("complete", this.internalGrants);
        this.$v.$reset();
      }
    },
  },
  created() {
    if (this.grants.length) {
      this.internalGrants = Array.from(this.grants);
    }
  },
};
</script>

<style scoped>
</style>
